<span [class]="spanClass()">
  <app-icons [icon]="icon()" width="16" svgClass="w-4 h-4"/>
</span>
@if (label()) {
  <span [class]="stepNameClass()">{{ label() }}</span>
}
